import React, { useEffect, useState } from "react";
import classes from "./ChildAddModal.module.scss";
import childChar1 from "../../static/images/character/child-char-1.png";
import childChar2 from "../../static/images/character/child-char-2.png";
import childChar3 from "../../static/images/character/child-char-3.png";
import childChar4 from "../../static/images/character/child-char-4.png";
import childChar5 from "../../static/images/character/child-char-5.png";
import childChar6 from "../../static/images/character/child-char-6.png";
import childChar7 from "../../static/images/character/child-char-7.png";
import cancelButton from "../../static/images/compare/cancel-image.png";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import { postUserPointOwnerChild } from "../../api/UserPointOwnerApi";

type ChildAddModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const iconOptions = [
  { iconType: "child-char-1", image: childChar1 },
  { iconType: "child-char-2", image: childChar2 },
  { iconType: "child-char-3", image: childChar3 },
  { iconType: "child-char-4", image: childChar4 },
  { iconType: "child-char-5", image: childChar5 },
  { iconType: "child-char-6", image: childChar6 },
  { iconType: "child-char-7", image: childChar7 },
];

const ChildAddModal = ({ isOpen, onClose }: ChildAddModalProps) => {
  const postChildApi = postUserPointOwnerChild();
  const [childName, setChildName] = useState("");
  const [birthday, setBirthday] = useState("");
  const [selectedIcon, setSelectedIcon] = useState(0);
  const trimmedChildName = childName.trim();
  const isChildNameValid = trimmedChildName.length > 0 && trimmedChildName.length <= 10;
  const isBirthdayValid = /^\d{8}$/.test(birthday);
  const isFormValid = isChildNameValid && isBirthdayValid;
  const isProcessing = postChildApi.state?.status === "processing";

  useEffect(() => {
    if (postChildApi.state?.status !== "success") {
      return;
    }
    setChildName("");
    setBirthday("");
    setSelectedIcon(0);
    postChildApi.reset();
    onClose();
  }, [postChildApi.state?.status]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (!isFormValid || isProcessing) {
      return;
    }

    postChildApi.post({
      childName: trimmedChildName,
      birthday,
      iconType: iconOptions[selectedIcon].iconType,
    });
  };

  const handleBirthdayChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBirthday(event.target.value.replace(/[^\d]/g, "").slice(0, 8));
  };

  const handleChildNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChildName(event.target.value.slice(0, 10));
  };

  return (
    <div className={classes.overlay} role="presentation">
      <div className={classes.overlayInner}>
        <div
          className={classes.modal}
          role="dialog"
          aria-modal="true"
          aria-labelledby="child-add-modal-title"
        >
          <img
            src={cancelButton}
            alt="閉じる"
            className={classes.closeButton}
            role="button"
            tabIndex={0}
            onClick={onClose}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                onClose();
              }
            }}
          />

          <div className={classes.formGroup}>
            <label className={classes.label} htmlFor="child-name" id="child-add-modal-title">
              お子さまのお名前（ニックネーム）は？
            </label>
            <input
              id="child-name"
              className={classes.textInput}
              type="text"
              value={childName}
              onChange={handleChildNameChange}
              maxLength={10}
            />
            {childName.length > 0 && !isChildNameValid && (
              <div className={classes.errorText}>10文字以内で入力してください。</div>
            )}
          </div>

          <div className={classes.formGroup}>
            <label className={classes.label} htmlFor="child-birthday">
              お子さまの生年月日は？
            </label>
            <div className={classes.hint}>西暦＋月日を半角で入力してください。</div>
            <input
              id="child-birthday"
              className={classes.textInput}
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={birthday}
              onChange={handleBirthdayChange}
              placeholder="20210528"
              maxLength={8}
            />
            {birthday.length > 0 && !isBirthdayValid && (
              <div className={classes.errorText}>生年月日は数字8桁で入力してください。</div>
            )}
          </div>

          <div className={classes.iconSection}>
            <div className={classes.label}>アイコンを選択してください。</div>
            <div className={classes.iconGrid} role="radiogroup" aria-label="お子さまのアイコン">
              {iconOptions.map((option, index) => (
                <label className={classes.iconOption} key={option.iconType}>
                  <img src={option.image} alt="" />
                  <input
                    type="checkbox"
                    name="child-icon"
                    checked={selectedIcon === index}
                    onChange={() => setSelectedIcon(index)}
                    aria-label={`アイコン${index + 1}`}
                  />
                </label>
              ))}
            </div>
          </div>

          <div className={classes.submitButton}>
            <SimpleButton
              label="これでOK!"
              width="180px"
              color={isFormValid ? "orange" : "gray"}
              isRadius={true}
              onClick={handleSubmit}
              disabled={!isFormValid || isProcessing}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChildAddModal;
